export default class Worker {
  constructor() {
    this.jobs = [];
  }
}
